//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Tag from '@/components/Shared/Tag'
import PROJECT_ROLES from '~/constants/project-roles'
export default {
  components: {
    Tag,
  },
  filters: {
    styleForActiveRow(errors) {
      if (errors.length > 0) {
        return 'is-danger'
      }
      return 'is-success'
    },
    textForActiveRow(errors) {
      if (errors.length > 0) {
        return 'Error de carga'
      }
      return 'Carga completa'
    },
  },
  props: {
    usersInfo: {
      type: Array,
      default: () => [],
    },
    role: {
      type: String,
      default: '',
    },
  },
  computed: {
    hasColumnRoleEnabled() {
      return this.role !== ''
    },
    isSupervisorRole() {
      return this.role === PROJECT_ROLES.SUPERVISOR
    },
  },
  methods: {
    isRowExpanded(row) {
      return this.$refs.massiveImportInfoUserTable.isVisibleDetailRow(row)
    },
    toggleDetails(row) {
      if (row.errors.length > 0) {
        this.$refs.massiveImportInfoUserTable.toggleDetails(row)
      }
    },
  },
}
